import React from 'react';
import AdminLayout from '@/components/AdminLayout';
import { Card, CardContent } from '@/components/ui/card';

export default function ReportsManager() {
  return (
    <AdminLayout title="Reports & Analytics">
      <Card className="bg-white border-slate-200 shadow-sm rounded-md">
        <CardContent className="pt-6">
          <p className="text-[#78716C]">
            View comprehensive revenue reports, utilization metrics, CSAT scores, and operational analytics.
          </p>
          <p className="text-sm text-[#A8A29E] mt-4">
            Coming soon: Revenue reports, occupancy analytics, survey results, and export capabilities.
          </p>
        </CardContent>
      </Card>
    </AdminLayout>
  );
}
